/**
 * Cipher context used for key derivation in payload encryption.
 * Different contexts ensure that request and response encryption use different derived keys,
 * even when using the same base HMAC secret.
 */
export enum PayloadCipherContext {
  REQUEST = 'request',
  RESPONSE = 'response'
}
